import type { ResourceType, ResourceTypeKeys } from 'types/common';

export const SWITCHER_LABELS = {
  SET_VALUE: 'Set Value',
  USER_INPUT: 'User Input',
} as const;

export const SPARK_RESOURCE_TYPES: Record<ResourceTypeKeys, ResourceType> = {
  CATEGORIES: 'categories',
  AI_PROVIDERS: 'AIProviders',
  AI_MODELS: 'AIModels',
  AI_MODEL_EXECUTION_PARAMETERS: 'AIModelExecutionParameters',
  STEP_PARAMETER: 'sparkStepParameters',
  INPUT_PARAMETER: 'sparkInputParameters',
  OUTPUT_PARAMETER: 'sparkOutputParameters',
  PARAMETER: 'parameters',
  INPUT_PARAMETER_PAGE: 'sparkInputParameterPages',
  OUTPUT_PARAMETER_PAGE: 'sparkOutputParameterPages',
  SPARKS: 'sparks',
  WORKSPACES: 'workspaces',
  SPARK_RUN_OUTPUTS: 'sparkRunOutputs',
  SPARK_RUN: 'sparkRuns',
  MEMORIES: 'memories',
  USAGE_STATISTICS: 'usageStatistics',
  SPARK_CATEGORIES: 'sparkCategories',
  MARKETPLACE_ACCOUNTS: 'marketplaceAccounts',
  STRIPE_PAYOUT: 'stripe/payout',
  STRIPE_ACCOUNT: 'stripe/account',
  STRIPE_CHECKOUT_SESSION: 'Stripe/Checkout/Session',
  STRIPE_INVOICES: 'stripe/invoices',
  APPLICATION_USERS: 'applicationUsers',
  ACCOUNT_ROLES: 'accountRoles',
  WORKSPACE_ROLES: 'workspaceRoles',
  WORKSPACE_USERS: 'workspaceUsers',
  MEMORY_CATEGORIES: 'memoryCategories',
  MEMORY_SEARCHES: 'memorySearches',
  ACCOUNT_USERS: 'accountUsers',
  ACCOUNTS: 'accounts',
  COUNTRIES: 'countries',
  BUSINESS_INDUSTRIES: 'businessIndustries',
  SPARK_BILLING_TYPES: 'SparkBillingTypes',
  LEGAL_STRUCTURES: 'legalStructures',
  BUSINESS_STAGES: 'businessStages',
  MARKET_APPROACHES: 'marketApproaches',
  GEOGRAPHIC_MARKETS: 'geographicMarkets',
  SPARK_TASKS: 'sparkTasks',
  SPARK_TASK_STATUS_TYPE: 'sparkTaskStatusTypes',
  MEMORY_STATUS_TYPES: 'memoryStatusTypes',
  SPARK_RATINGS: 'sparkRatings',
  SPARK_FAVOURITES: 'sparkFavourites',
  SPARK_RUN_FAVOURITES: 'sparkRunFavourites',
  SPARK_IMAGES: 'sparkImages',
  MEMORY_IMAGES: 'memoryImages',
  KEY_OBJECTIVES: 'keyObjectives',
  MAIN_CHALLENGES: 'mainChallenges',
  ACCOUNT_PAYMENT_METHODS: 'accountPaymentMethods',
  SPARK_STEPS: 'sparkSteps',
  FLAG_REASONS: 'flagReasons',
  USER_FLAGS: 'userFlags',
  COMPANY_OVERVIEW_KEY_OBJECTIVES: 'companyOverviewKeyObjectives',
  COMPANY_OVERVIEW_MAIN_CHALLENGES: 'companyOverviewMainChallenges',
  COMPANY_OVERVIEW_MARKET_APPROACHES: 'companyOverviewMarketApproaches',
  PERSONAL_OVERVIEWS: 'personalOverviews',
  PERSONAL_OVERVIEW_KEY_OBJECTIVES: 'personalOverviewKeyObjectives',
  PERSONAL_OVERVIEW_MAIN_CHALLENGES: 'personalOverviewMainChallenges',
  GENDERS: 'Genders',
  COMPANY_OVERVIEWS: 'companyOverviews',
  SPARK_DIAGNOSTICS: 'sparkDiagnostics',
  SPARK_PRIVACY_TYPES: 'sparkPrivacyTypes',
  SPARK_RUN_RECOMMENDATIONS: 'sparkRunRecommendations',
  SPARK_RUN_INPUT_PARAMETER_RECOMMENDATIONS:
    'SparkRunInputParameterRecommendations',
  SPARK_RUN_INPUT_PARAMETER_RECOMMENDATIONS_SOURCE:
    'sparkRunInputParameterRecommendationSources',
  WELCOME: 'welcome',
  SUBSCRIPTION_TYPE: 'subscriptionTypes',
  SUBSCRIPTION_BILLING_INTERVALS: 'subscriptionBillingIntervals',
  SUBSCRIPTION_CREDIT_OPTIONS: 'subscriptionCreditOptions',
  STRIPE_ACCOUNT_STATUS_TYPE: 'stripeAccountStatusTypes',
  UI_COMPONENTS: 'uiComponents',
  SPARK_STEP_REFERENCES: 'sparkStepReferences',
  USER: 'user',
  FORGOT_PASSWORD: 'user/forgotPassword',
  VALIDATE_TOKEN: 'user/validateToken',
  CHANGE_PASSWORD: 'user/changePassword',
  MEMORY_FAVOURITES: 'memoryFavourites',
  FILES: 'files',
  MEMORY_FILES: 'memoryFiles',
  MEMORY_RATINGS: 'memoryRatings',
  MEMORY_SEARCH_RESULTS: 'memorySearchResults',
  MEMORY_SEARCH_RESULT_SOURCES: 'MemorySearchResultSources',
  WORKSPACE_RECOMMENDED_MEMORIES: 'WorkspaceRecommendedMemories',
  WORKSPACE_RECOMMENDATIONS: 'workspaceRecommendations',
  MEMORY_PRIVACY_TYPES: 'memoryPrivacyTypes',
  PLUGINS: 'plugins',
  SPARK_OUTPUT_REFERENCES: 'sparkOutputReferences',
  UI_COMPONENT_VALIDATION_RULES: 'uIComponentValidationRules',
  VALIDATION_RULE_OPTIONS: 'validationRuleOptions',
  STRIPE_SPARK_PAYMENT: 'stripe/spark/payment',
  STRIPE_MEMORY_PAYMENT: 'stripe/memory/payment',
  MEMORY_BILLING_TYPES: 'MemoryBillingTypes',
  PARAMETER_VALIDATION_RULES: 'parameterValidationRules',
  PLUGIN_ACTION_PARAMETERS: 'pluginActionParameters',
  SPARK_RUN_INPUT_PARAMETERS: 'sparkRunInputParameters',
  FORMS: 'forms',
  PLUGIN_FUNCTION_PARAMETERS: 'pluginFunctionParameters',
  SPARK_CONTENT_CARD_CATEGORIES: 'SparkContentCardCategories',
  ACCOUNT_SPARK_SUBSCRIPTIONS: 'AccountSparkSubscriptions',
  ACCOUNT_MEMORY_SUBSCRIPTIONS: 'AccountMemorySubscriptions',
  MEMORY_CONTENT_CARD_CATEGORIES: 'MemoryContentCardCategories',
  FAVOURITE_LIST: 'favouriteLists',
  FILE_UPLOADS: 'fileUploads',
  SPARK_STATUS_TYPES: 'sparkStatusTypes',
  PLUGIN_CONNECTIONS: 'pluginConnections',
  PLUGIN_AUTHENTICATION_PARAMETERS: 'pluginAuthenticationParameters',
  PLUGIN_AUTHENTICATION: 'pluginAuthentications',
  AUTHENTICATION_TYPE: 'authenticationTypes',
  MEMORY_DIAGNOSTICS: 'memoryDiagnostics',
  PLUGIN_CONNECTIONS_CONFIGURE: 'PluginConnections/Configure',
  PLUGIN_CONNECTIONS_TEST: 'PluginConnections/Test',
  PLUGIN_AUTHENTICATIONS_AUTHORIZE_CONNECTION:
    'PluginAuthentications/AuthorizeConnection',
  PLUGIN_CONNECTIONS_STATUS_TYPES: 'pluginConnectionStatusTypes',
  BOARD_NODES: 'boardNodes',
  RESOURCE_SHARES: 'resourceShares',
  BOARDS: 'boards',
  BOARD_NODE_TYPES: 'boardNodeTypes',
  BOARD_ENTITY_TYPES: 'boardEntityTypes',
  BOARD_ACTIONS: 'boardActions',
  ACCESS_LEVELS: 'accessLevels',
  RESOURCE_ACCESS_LEVELS: 'resourceAccessLevels',
  SHARE_TYPES: 'shareTypes',
  INVITE_STATUS_TYPES: 'inviteStatusTypes',
  RESOURCE_TYPES: 'resourceTypes',
  CONVERSATION_STATERS: 'ConversationStarters',

  BOARD_CHATS: 'boardChats',
  CHATS: 'chats',
  CHAT_MESSAGES: 'chatMessages',
  CHAT_MESSAGES_STREAM: 'chatMessages/stream',
  TAGS: 'Tags',
  CHAT_MESSAGES_BOARD: 'chatMessages/boards',
  CHAT_MESSAGES_BOARD_STREAM: 'chatMessages/boards/stream',
  CHAT_MESSAGE_RATING_TYPES: 'chatMessageRatingTypes',
  PROMPT_FUNCTIONS: 'promptFunctions',
  MEMORY_CHATS: 'memoryChats',
  CHAT_PLUGIN_FUNCTIONS: 'chatPluginFunctions',
  TRANSCRIPTIONS: 'transcriptions',
  TRANSCRIPTION_STATUS_TYPES: 'transcriptionStatusTypes',
} as const;

export const UN_GROUPED_PARAMETER_PAGE = 'Unassigned' as const;

export const DND_ITEMS_TYPES = {
  PARAMETER_PAGE: 'parameterPage',
  PARAMETER: 'parameter',
} as const;

export const VALUE_TYPES = {
  INPUT_VALUES: 'inputValues',
  OUTPUT_VALUES: 'outputValues',
} as const;

export const INPUT_OUTPUT_CONSTANT = {
  INPUT: 'input',
  OUTPUT: 'output',
} as const;

export const STATUS_TAGS = {
  PENDING: 'Pending',
  RUNNING: 'Running',
  SUCCESS: 'Success',
  ERROR: 'Error',
  PAUSED: 'Paused',
  DELAYED: 'Delayed',
  PENDING_PAYMENT: 'Pending Payment',
  IMPORT: 'Import',
  IMPORTING: 'Importing',
  ACTIVE: 'Active',
} as const;

export const ROLE_TAGS = {
  USER: 'user',
  ADMIN: 'Admin',
} as const;

export const SPARK_DRAWER_TYPES = {
  input: 'input',
  output: 'output',
  spark: 'sparkStep',
  boardNode: 'boardNode',
} as const;

export const STRIPE_URL = {
  EDIT_PAYMENT:
    'https://billing.stripe.com/p/login/test_4gw8zE5LA7kC1MYaEE?prefilled_email=',
} as const;

export type QueryOptions = {
  shouldInvalidatedOnSuccess?: boolean;
  enabled?: boolean;
};
export const MEMORY_PAYMENT_REQUIRED_ERROR = 'Payment Required';

export const ID_MAP_KEYS = {
  ID: 'id',
};

export const TARGET_VALUES = {
  self: '_self',
  blank: '_blank',
  parent: '_parent',
  top: '_top',
  modal: 'modal',
};
export const SPARK_BADGE_TYPES = {
  Status: 'Status',
  Category: 'Category',
  Price: 'Price',
  Subscription: 'Subscription',
  Trial: 'Trial',
  Creator: 'Creator',
  Info: 'Info',
};
export const SPARK_MODAL_TYPES = {
  delete: 'delete',
  favourite: 'favourite',
  share: 'share',
  review: 'review',
  report: 'report',
  archive: 'archive',
};

export const CATEGORIES = {
  BUSINESS: 'Business',
  PERSONAL: 'Personal',
};
